import { OVERDRIVE_RULES, REACTOR_STORM_RULES } from "../../config/gameplay";
import { nonNegative } from "../../utils/math";
import { createDefaultTimedEventState } from "./defaults";
import type { OverdriveEventState, TimedEventState } from "./types";

export function sanitizeTimedEvents(raw: unknown): TimedEventState {
  const defaults = createDefaultTimedEventState();
  if (!isRecord(raw)) {
    return defaults;
  }

  return {
    overdrive: sanitizeOverdrive(raw.overdrive, defaults),
    reactorStorm: sanitizeReactorStorm(raw.reactorStorm, defaults)
  };
}

function sanitizeOverdrive(raw: unknown, defaults: TimedEventState) {
  if (!isRecord(raw)) {
    return defaults.overdrive;
  }

  const activeSeconds = Math.min(OVERDRIVE_RULES.durationSeconds, nonNegative(raw.activeSeconds));
  const activeKind: OverdriveEventState["activeKind"] = raw.activeKind === "prestige" || raw.activeKind === "normal" ? raw.activeKind : null;
  return {
    activeKind: activeSeconds > 0 ? activeKind ?? "normal" : null,
    activeSeconds,
    cooldownSeconds: activeSeconds > 0 ? 0 : Math.min(OVERDRIVE_RULES.cooldownSeconds, nonNegative(raw.cooldownSeconds, defaults.overdrive.cooldownSeconds)),
    prestigeWindowStartedAtUnixSeconds: nonNegative(raw.prestigeWindowStartedAtUnixSeconds),
    prestigeUsesInWindow: Math.min(OVERDRIVE_RULES.prestigeUsesPerWindow, Math.floor(nonNegative(raw.prestigeUsesInWindow)))
  };
}

function sanitizeReactorStorm(raw: unknown, defaults: TimedEventState) {
  if (!isRecord(raw)) {
    return defaults.reactorStorm;
  }

  return {
    cooldownSeconds: Math.min(REACTOR_STORM_RULES.cooldownSeconds, nonNegative(raw.cooldownSeconds))
  };
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
